export default __webpack_public_path__ + "static/media/lessCircleLight.add23f1c.svg";